import styled, { css } from 'styled-components';
import { InputBaseCSS, InputErrorMessageCSS, InputLabelCSS, InputMessageCSS, InputRequiredAsteriskCSS, InputWrapperCSS, OnFocusInput, } from '../common/index.js';
import { BKJComboBox } from '../BKJComboBox/index.js';
export const InputLabel = styled.label `
  ${InputLabelCSS}
`;
export const ErrorMessage = styled.label `
  ${InputErrorMessageCSS}
`;
export const InputMessage = styled.label `
  ${InputMessageCSS};

  ${({ isMaxLimitReached }) => {
    if (isMaxLimitReached)
        return css `
        color: ${({ theme }) => theme.colors.ErrorDefault};
      `;
    return css ``;
}}
`;
export const RequiredAsterisk = styled(InputLabel) `
  ${InputRequiredAsteriskCSS}
`;
export const BKJPillDropdownWrapper = styled.div `
  ${InputWrapperCSS};

  display: flex;
  flex-direction: column;
  z-index: 0;
`;
export const TextAreaWrapper = styled.div `
  ${InputBaseCSS};

  ${({ isFocused }) => isFocused &&
    css `
      ${OnFocusInput()}
    `}

  height: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  overflow-y: overlay;
  position: relative;

  z-index: 1;

  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-bottom: none;

  ${({ isFocused, hasValue, theme }) => !isFocused &&
    !hasValue &&
    css `
      border-bottom: 1px solid ${theme.colors.Grey6};
    `};
`;
const calculateMarginTop = ($dropdownOffset) => {
    const baseMargin = -30;
    const offset = $dropdownOffset ? $dropdownOffset - 38 : 0;
    return baseMargin - offset;
};
export const BKJPillDropdownComboBox = styled(BKJComboBox) `
  ${({ hasValue, $dropdownOffset }) => hasValue
    ? css `
          input {
            border-top-left-radius: 0px !important;
            border-top-right-radius: 0px !important;
            margin-top: ${calculateMarginTop($dropdownOffset)}px;
            height: ${$dropdownOffset}px;
            color: transparent;
          }
          .bkj-combobox-dropdown-icon {
            svg {
              display: none;
            }
          }
        `
    : css `
          input {
            height: 46px;
          }
        `};
`;
export const ArrowIconWrapper = styled.div `
  position: absolute;
  top: 7px;
  right: 8px;
  pointer-events: none;
`;
//# sourceMappingURL=BKJPillDropdown.styled.js.map